export default "__VITE_ASSET__CCDrPWs___"